module.exports = __webpack_public_path__ + "img/21.c63c5291.png";